var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{staticClass:"uku-group-avatar",class:_vm.className,attrs:{"left":"","size":_vm.size}},[_c('span',{class:[_vm.text_class, 'font-weight-medium white--text']},[_vm._v(" "+_vm._s(_vm.initials)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }